import { Button, Modal } from "react-bootstrap";

const ModalComponent = ({
  show,
  handleClose,
  size,
  title,
  children,
  buttonData,
  dialogClassName = "",
}) => {
  return (
    <Modal show={show} onHide={handleClose} size={size} dialogClassName={dialogClassName || ""}>
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
      <Modal.Footer
        className="p-0 mt-0 padding-outside-btn-new-provider"
        style={{ borderTop: "none" }}
      >
        {buttonData.map((button, index) => (
          <Button
            key={index}
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            variant={button.variant}
            onClick={button.onClick}
            disabled={button.disabled}
          >
            {button.text}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
